import {kosherTab} from "./consts.js";

export const getAccuracyResultsFilterTitle = accuracyResults => {
    const productPropertiesCount = (accuracyResults?.productProperties || []).length;
    const selectedKoshers = accuracyResults?.foodOptions || [];
    const totalSelectedKoshers = accuracyResults?.kosherTypesKey === kosherTab.anyKosher ? 1 : selectedKoshers.length;
    const totalLocationOptions = (accuracyResults?.activityRequestsProperties || []).length;
    return productPropertiesCount + totalSelectedKoshers + totalLocationOptions;
};
